/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	createStore,
	createStateHook,
	createActionsHook,
	type Action,
	type BoundActions,
	type HookActionsFunction,
	type HookStateFunction,
} from '@atlassian/react-sweet-state';
import { type ReturnFocusTo, type State, initialState } from './ReturnFocusTo.types.tsx';
import { actions, type Actions } from './setReturnFocusTo.tsx';
import { getReturnFocusTo } from './getReturnFocusTo.tsx';

const Store = createStore<State, Actions>({
	name: 'JiraSoftwareModalDialog',
	initialState,
	actions,
});

export const useModalDialogActions: HookActionsFunction<
	BoundActions<
		State,
		{
			readonly setReturnFocusTo: (returnFocusTo: ReturnFocusTo | null) => Action<State>;
		}
	>
> = createActionsHook(Store);

export const useReturnFocusTo: HookStateFunction<ReturnFocusTo | null, void> = createStateHook(
	Store,
	{
		selector: getReturnFocusTo,
	},
);
